import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

import { Currency, currencyList } from '@feature/utils';

export interface CurrencySelectControlProps<T extends FieldValues> extends Omit<EnumSelectControlProps<T>, 'options'> {
  currencies?: readonly Currency[];
}

export function CurrencySelectControl<T extends FieldValues>(props: CurrencySelectControlProps<T>) {
  const { currencies = currencyList, ...rest } = props;
  const options = useMemo(() => currencies.map(c => ({ value: c, label: c })), [currencies]);

  return (
    <EnumSelectControl
      {...rest}
      options={options}
    />
  );
}
